import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CHANGELOG } from '../lib/changelog';

export default function Changelog() {
  return (
    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <div className="flex items-center space-x-4 mb-6">
        <div className="flex items-center space-x-2">
          <Link
            to="/dashboard"
            className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          >
            <Home className="h-5 w-5 mr-2" />
            Dashboard
          </Link>
          <span className="text-gray-400">/</span>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Changelog</h1>
      </div>

      <div className="bg-white shadow rounded-lg p-6">
        <div className="space-y-8">
          {CHANGELOG.map((release) => (
            <div key={release.version} className="relative">
              <div className="flex items-baseline space-x-4">
                <h2 className="text-lg font-semibold text-orange-600">
                  v{release.version}
                  {release.version.includes('beta') && (
                    <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      Beta
                    </span>
                  )}
                </h2>
                <span className="text-sm text-gray-500">{release.date}</span>
              </div>
              <div className="mt-3 ml-4 space-y-3">
                {release.changes.map((change, index) => (
                  <div
                    key={index}
                    className="flex items-start"
                  >
                    <div className="relative flex h-6 items-center">
                      <div className="absolute left-0 h-full w-px bg-gray-200 -ml-px"></div>
                      <div className="relative h-2 w-2 rounded-full bg-gray-300"></div>
                    </div>
                    <p className="ml-4 text-gray-700">{change}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}